import { Button } from "@/components/ui/button";
import { AlertTriangle, RefreshCw } from "lucide-react";

// 배송엑셀 상단 stale 배너 — dumb 컴포넌트 (상태 없음, 클릭만 위로 전달).
// 카운트는 "배송정보 행" 기준이다. order_id 중복 행이 프로드에 실존하므로
// '주문 N건'이라 표기하지 않는다 (플랜 codexloop 합의).

interface ShippingStaleSyncBannerProps {
  /** 정산서와 다른 배송정보 행 수 (스캔 중엔 마지막 확정 카운트 — 레이아웃 안정화) */
  staleCount: number;
  scanFailed: boolean;
  /** 재스캔 진행 중 — 배너를 유지한 채 버튼만 잠근다(사라졌다 재등장하는 출렁임 방지) */
  isChecking?: boolean;
  onOpen: () => void;
  onRetry: () => void;
}

export function ShippingStaleSyncBanner({
  staleCount,
  scanFailed,
  isChecking = false,
  onOpen,
  onRetry,
}: ShippingStaleSyncBannerProps) {
  if (scanFailed) {
    return (
      <div
        role="alert"
        className="flex items-center justify-between px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-lg mb-2"
      >
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <AlertTriangle className="h-4 w-4 text-gray-400" />
          <span>배송정보와 정산서의 비교에 실패했습니다.</span>
        </div>
        <Button
          variant="outline"
          size="sm"
          className="text-xs h-8 gap-1.5"
          onClick={onRetry}
        >
          <RefreshCw className="h-3.5 w-3.5" />
          다시 확인
        </Button>
      </div>
    );
  }

  if (staleCount <= 0) return null;

  return (
    <div
      aria-live="polite"
      className="flex items-center justify-between px-4 py-2.5 bg-amber-50 border border-amber-200 rounded-lg mb-2"
    >
      <div className="flex items-center gap-2 text-sm text-gray-700">
        <AlertTriangle className="h-4 w-4 text-amber-500" />
        <span>
          정산서와 다른 배송정보 <span className="font-semibold text-amber-700">{staleCount}건</span>이 있습니다.
        </span>
        <span className="hidden md:inline text-xs text-gray-500">
          이대로 다운로드하면 오배송이나 미배송이 생길 수 있습니다.
        </span>
      </div>
      <Button
        size="sm"
        className="text-xs h-8 bg-amber-500 hover:bg-amber-600 text-white shrink-0"
        disabled={isChecking}
        onClick={onOpen}
      >
        {isChecking ? (
          <>
            <RefreshCw className="h-3.5 w-3.5 animate-spin mr-1" />
            확인 중
          </>
        ) : (
          "확인하고 반영"
        )}
      </Button>
    </div>
  );
}
